import React, { useState, useEffect, useMemo } from "react";
import { MDBDataTable } from "mdbreact";
import { Row, Col, Card, CardBody, CardTitle, Button } from "reactstrap";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { fetchAllPages } from "../../common/tableData";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { withTranslation } from "react-i18next";

const CatExercise = ({ t }) => {
  const { subid, slug } = useParams();
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [iscategory, setIscategory] = useState([]);

  const getExercisesData = async () => {
    setIsLoading(true);
    try {
      const exercises = await fetchAllPages(
        (page, pageSize) =>
          `exercise/exercises/?categories=${slug}&page=${page}&page_size=${pageSize}`
      );

      const category = exercises?.[0]?.categories?.find(
        (cat) => cat?.id === parseInt(slug, 10)
      );
      setIscategory(category);
      setRows(exercises);
    } catch (error) {
      console.error("Error fetching exercise data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getExercisesData();
  }, [slug]);

  const handleEdit = (id) => {
    navigate(`/category/edit-exercise/${subid}/${id}`);
  };

  const handleAddVideo = (id) => {
    navigate(`/category/videos/${subid}/${slug}/${id}`);
  };

  const tableData = useMemo(
    () => ({
      columns: [
        {
          label: t("ID"),
          field: "id",
          sort: "asc",
          width: 50,
        },
        {
          label: t("Name"),
          field: "exercise_name",
          sort: "asc",
          width: 150,
        },
        {
          label: t("Active"),
          field: "status",
          sort: "asc",
          width: 100,
        },
        {
          label: t("Image"),
          field: "image",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Add Video"),
          field: "addVideo",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
        {
          label: t("Edit"),
          field: "edit",
          sort: "disabled",
          searchable: false,
          width: 100,
        },
      ],
      rows: rows.map((row) => ({
        ...row,
        image: <img src={row.image || "https://via.placeholder.com/50"} alt="Exercise" width="50" height="50" />,
        edit: <Button color="secondary" onClick={() => handleEdit(row.id)}>{t("Edit")}</Button>,
        addVideo: <Button color="primary" onClick={() => handleAddVideo(row.id)}>{t("Add Videos")}</Button>,
        status: row.status ? t("True") : t("False"),
      })),
    }),
    [rows, t]
  );

  return (
    <React.Fragment>
      <div className="page-content">
        <div className="container-fluid">
          <Breadcrumbs maintitle="Home" title={t("Pain Area Body Parts")} titleLink={`/category/sub-category/${subid}`} breadcrumbItem={t("Exercises")} />
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <div className="d-flex justify-content-between align-items-center mb-4">
                    <CardTitle className="h4">{iscategory?.name} {t("Exercises")} Data</CardTitle>
                    <Button color="primary" onClick={() => { navigate(`/category/create-exercise/${subid}/${slug}`); }}>
                      <i className="typcn typcn-plus"></i> {t("Add New Exercise")}
                    </Button>
                  </div>

                  <MDBDataTable
                    responsive
                    striped
                    bordered
                    paging
                    searching
                    sortable
                    order={["id", "asc"]}
                    entries={10}
                    entriesOptions={[10, 25, 50, 100]}
                    displayEntries
                    info
                    infoLabel={[t("Showing"), t("to"), t("of"), t("entries")]}
                    paginationLabel={["<", ">"]}
                    searchLabel={t("Search")}
                    noRecordsFoundLabel={t(isLoading ? "Loading..." : "No records found")}
                    data={tableData}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(CatExercise);
